var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"community"},[_c('Banner',{attrs:{"page":"community"}}),_c('ProjectRankList'),_c('UserRankList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }